import React from 'react';

interface SpeakerTestProps {
  isPlayingTone: boolean;
  speakerConfirmed: boolean | null;
  onPlayTone: () => void;
  onConfirm: (heard: boolean) => void;
}

export const SpeakerTest: React.FC<SpeakerTestProps> = ({
  isPlayingTone,
  speakerConfirmed,
  onPlayTone,
  onConfirm,
}) => {
  return (
    <div
      style={{
        borderRadius: '12px',
        border: '1px solid rgba(255,255,255,0.09)',
        background: 'rgba(0,0,0,0.35)',
        padding: '14px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}
    >
      {/* Header row */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '18px' }}>🔊</span>
          <div>
            <h4 style={{ margin: 0, fontSize: '11px', fontWeight: 700, color: '#F1F5F9', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              Speaker / Audio Output Test
            </h4>
            <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#64748B' }}>
              Verify you can hear the simulated customer persona's voice.
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onPlayTone}
          disabled={isPlayingTone}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: 'rgba(99,102,241,0.12)',
            border: '1px solid rgba(99,102,241,0.30)',
            borderRadius: '8px',
            color: isPlayingTone ? '#64748B' : '#818CF8',
            fontSize: '12px',
            fontWeight: 600,
            padding: '6px 12px',
            cursor: isPlayingTone ? 'not-allowed' : 'pointer',
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          {isPlayingTone ? (
            <>
              <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#818CF8', display: 'inline-block', animation: 'pulse 1s infinite' }} />
              Playing Tone...
            </>
          ) : (
            <>▶ Play Test Sound</>
          )}
        </button>
      </div>

      {/* Confirmation row */}
      <div
        style={{
          borderTop: '1px solid rgba(255,255,255,0.06)',
          paddingTop: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        <span style={{ fontSize: '12px', color: '#CBD5E1', fontWeight: 500 }}>Did you hear the chime clearly?</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button
            type="button"
            onClick={() => onConfirm(true)}
            style={{
              borderRadius: '7px',
              fontSize: '12px',
              fontWeight: 600,
              padding: '5px 12px',
              cursor: 'pointer',
              border: speakerConfirmed === true ? 'none' : '1px solid rgba(255,255,255,0.10)',
              background: speakerConfirmed === true ? '#059669' : 'rgba(255,255,255,0.05)',
              color: speakerConfirmed === true ? '#fff' : '#94A3B8',
            }}
          >
            ✓ Yes, I heard it
          </button>
          <button
            type="button"
            onClick={() => onConfirm(false)}
            style={{
              borderRadius: '7px',
              fontSize: '12px',
              fontWeight: 600,
              padding: '5px 12px',
              cursor: 'pointer',
              border: speakerConfirmed === false ? 'none' : '1px solid rgba(255,255,255,0.10)',
              background: speakerConfirmed === false ? '#DC2626' : 'rgba(255,255,255,0.05)',
              color: speakerConfirmed === false ? '#fff' : '#94A3B8',
            }}
          >
            ✕ No sound
          </button>
        </div>
      </div>
    </div>
  );
};
